$(function() {

    $('.slider-testimonials-content').slick({
        accessibility: false,
        arrows: false,
        asNavFor: '.slider-testimonials-nav',
        fade: true,
        slidesToScroll: 1,
        slidesToShow: 1,
    });
    $('.slider-testimonials-nav').slick({
        accessibility: false,
        adaptiveHeight: true,
        arrows: false,
        asNavFor: '.slider-testimonials-content',
        cssEase: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
        dots: false,
        focusOnSelect: true,
        slidesToScroll: 1,
        slidesToShow: 4,
        speed: 1000,
        vertical: true,
        verticalSwiping: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 5,
                    vertical: false,
                    verticalSwiping: false,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 4,
                    vertical: false,
                    verticalSwiping: false,
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 3,
                    vertical: false,
                    verticalSwiping: false,
                }
            }
        ]
    })
    // .on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    //     $('.slider-prev').removeClass('slider-prev');
    //     $('.slick-current').prev().addClass('slider-prev');
    // })
});


var maxHeight = -1;
$('.slider-testimonials-nav .slick-slide').each(function() {
    if ($(this).height() > maxHeight) {
        maxHeight = $(this).height();
    }
});
$('.slider-testimonials-nav .slick-slide').each(function() {
    if ($(this).height() < maxHeight) {
        $(this).css('margin', Math.ceil((maxHeight-$(this).height())/2) + 'px 0');
    }
});
